/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './StylesView.scss';
import BasePanel from '../../Panels';
import AddStyle from '../../Panels/AddStyle';
import StyleList from '../../Panels/StyleList';
import NewStyle from '../../Panels/NewStyle';

class StylesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newStyleControl: null,
    }
    this.onModify = this.onModify.bind(this);
    this.onAddNewStyle = this.onAddNewStyle.bind(this);
    this.onCloseNewStyle = this.onCloseNewStyle.bind(this);
  }

  onAddNewStyle = (e, nazwa) => {
    e.preventDefault();
    this.setState({
      newStyleControl: (
        <BasePanel
          fullWidth
          user={this.props.user}
          userHasFeatureCode="0003"
          panelType="warning"
          panelTitle={`Konfiguracja nowego stylu ${nazwa}`}
        >
          <NewStyle
            styleName={nazwa}
            isNew
            onCloseNewStyle={this.onCloseNewStyle}
            district={this.props.district}
          />
        </BasePanel>
      ),
    });
  };

  onCloseNewStyle = () => this.setState({ newStyleControl: null });

  onModify = (e, i) => {
    e.preventDefault();
    this.setState({
      newStyleControl: (
        <BasePanel
          fullWidth
          user={this.props.user}
          userHasFeatureCode="0003"
          panelType="danger"
          panelTitle={`Edycja stylu ${this.props.district.styles[i].nazwa}`}
        >
          <NewStyle
            styleName={this.props.district.styles[i].nazwa}
            isNew={false}
            onCloseNewStyle={this.onCloseNewStyle}
            district={this.props.district}
          />
        </BasePanel>
      ),
    });
  }

  render() {
    return (
      <div>
        <BasePanel
          user={this.props.user}
          userHasFeatureCode="0003"
          panelType="info"
          panelTitle="Lista styli"
        >
          <StyleList district={this.props.district} onModify={this.onModify} />
        </BasePanel>
        <BasePanel
          user={this.props.user}
          userHasFeatureCode="0003"
          panelType="info"
          panelTitle="Import styli z pliku sld"
        >
          <AddStyle onAddNewStyle={this.onAddNewStyle} onCloseNewStyle={this.onCloseNewStyle} />
        </BasePanel>
        {this.state.newStyleControl ? this.state.newStyleControl : null}
      </div>
    );
  }
}

StylesView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(StylesView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/StylesView/StylesView.js